import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolCommunitySource } from '../../models/patrol-community-source.model';

@Component({
  selector: 'app-patrol-community-source-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe, RouterLink],
  templateUrl: './patrol-community-source-card.component.html',
  styleUrl: './patrol-community-source-card.component.scss',
})
export class PatrolCommunitySourceCardComponent {
  source = input.required<PatrolCommunitySource>();
  active = input(false);

  toggled = output<boolean>();

  onToggleClick(event: Event): void {
    event.stopPropagation();
    if (!this.source().available) {
      return;
    }
    this.toggled.emit(!this.active());
  }
}
